import { generateShortId } from '..'
import { timestamp } from '../tools';
import { Place } from './Place'
import { RouteGeometry } from './RouteGeometry'
import { RouteSettings } from './RouteSettings'


export type RouteId = string & { readonly tag: unique symbol };

export interface RouteTimestamps {
  created: number;
  updated: number;
}
export interface RouteRoles {
  owner: string;
  driver?: string;
}
export interface DBRoute {
  live: boolean;
  calculated: boolean;
  distance: number;
  duration: number;
  durationDriving: number;
  settings: RouteSettings;
  timestamps: RouteTimestamps;
  roles: RouteRoles;
  places: Place[];

  migrationId: null | string;
}
export interface Route extends DBRoute {
  id: string;
  geometry: RouteGeometry;
  loading: boolean;
  saved: boolean;
}
export interface Routes {
  [routeId: string]: Route;
}

export const routeModel = (ownerId: string, routeSettings: RouteSettings): Route => {
  return {
    id: generateShortId(),
    loading: false,
    saved: false,
    roles: { owner: ownerId },
    settings: {...routeSettings},
    live: false,
    calculated: true,
    distance: 0,
    duration: 0,
    durationDriving: 0,
    timestamps: { created: timestamp(), updated: timestamp() },
    places: [],
    geometry: { legs: [] },
    
    migrationId: null
  }
}